export default __webpack_public_path__ + "static/media/Snd_ClowerE.248c2800.mp3";